import { defineCopy } from "../intl";

import { MENU_LINKS_COPY_EN_US } from "./en-us/menu-links.copy";
import { MENU_LINKS_COPY_ES_ES } from "./es-es/menu-links.copy";

/**
 * Textos do menu do creator: os rótulos das quatro seções e o `label`/
 * `collabLabel` de cada item, indexado por `KEY_LINK`.
 */
export const MENU_LINKS_COPY_PT_BR = {
  sections: {
    creativeCommand: "Seu comando criativo",
    ideasStudio: "Estúdio de ideias",
    moneyOnTheTable: "Dinheiro na mesa",
    yourImpact: "Seu impacto",
  },
  links: {
    dashboard: { label: "Painel" },
    agency: { label: "Creators" },
    flow: { label: "Fluxo da semana" },
    calendar: { label: "Calendário" },
    notes: { label: "Notas" },
    tasks: { label: "Central de conteúdo" },
    publi: { label: "Central de campanhas" },
    finances: { label: "Finanças" },
    calculator: { label: "Calculadora de publi", collabLabel: "Propostas" },
    performance: { label: "Desempenho" },
  },
  /**
   * Nome curto de cada destino na barra inferior do celular (TAM-259): o
   * nome fica embaixo do ícone, em 11px, e "Central de conteúdo" não cabe
   * num quinto de 390px.
   */
  tabLabels: {
    dashboard: "Painel",
    agency: "Creators",
    flow: "Fluxo",
    calendar: "Calendário",
    notes: "Notas",
    tasks: "Conteúdo",
    publi: "Campanhas",
    finances: "Finanças",
    calculator: "Calculadora",
    performance: "Desempenho",
    proposals: "Propostas",
  },
  menu: "Menu",
} as const;

export const MENU_LINKS_COPY = defineCopy(MENU_LINKS_COPY_PT_BR, {
  "en-US": MENU_LINKS_COPY_EN_US,
  "es-ES": MENU_LINKS_COPY_ES_ES,
});
